<div class="list-sources__container">
  <div class="list-sources__header">
    <div class="list-sources__header-title">
      <span class="fs__lg fw__500">Sources</span>
    </div>
  </div>

  <div class="list-sources__list">
    <mat-action-list>
      @for (source of sources.editable$(); track source.id) {
        <div class="list-sources__list-row">
          <empathy-list-source-item
            [active]="source.id === sources.active$().value.id"
            [source]="source"
            (activate)="sources.activeIndex$.set($index)"
          ></empathy-list-source-item>
        </div>
      }
    </mat-action-list>
  </div>
</div>
